export default {
  /**
   * 現在の履歴スタックを返す
   * この getters.stack は開発用です
   *
   * @param {State} state
   * @returns {Array} 現在の履歴スタックを返す
   */
  stack (state) {
    return state.stack
  },

  /**
   * 履歴を全て返す
   *
   * @param {State} state
   * @returns {Number}
   */
  allHistory (state) {
    return state
  },

  /**
   * 現在の履歴位置を返す
   *
   * @param {State} state
   * @returns {Number} 現在の履歴位置を返す。0 は現在を指す
   */
  currentIndex (state) {
    return state.index
  },

  /**
   * 対象パスの履歴位置を返す
   * 検索範囲は現在より過去のみを検索する
   *
   * @param {State} state
   * @param {String} path 対象のパス
   * @returns {Number} 見つかったら履歴位置を返す。見つからなければ -1 を返す
   */
  findIndex (state) {
    return path => state.stack.findIndex((item, index) => index >= state.index && item.path === path)
  }
}
